import {IAreaQueryService} from "../services/area_query";
import {IColumn, ILayerQueryLayer, ILayerQueryResult} from "../services/layer_query";
import {ITreeMapData} from "../visualisation/treemap";

interface AreaQueryChartScope extends ng.IScope {
	title: string;
	treemapData: any;
	barChartData: any;
	chart: string;
	btnClass(chart: string) : string|object;
}

export class AreaQueryChartCtrl {
	public static $inject = [
		'$scope',
		'areaQueryService'
	];

	constructor($scope: AreaQueryChartScope, areaQueryService: IAreaQueryService<ILayerQueryResult>) {
		$scope.title;
		$scope.chart = 'bubble';

		let nameValueToObject = (data: IColumn[]): object => {
			let out = {};
			data.forEach((col: IColumn) => {
				out[col.name] = col.value;
			});
			return out;
		};

		let sumChildren = (children : ITreeMapData[]) => children.reduce((theSum, ch) => theSum + ch.value, 0);

		let layerToTreeMapNode = (layer: ILayerQueryLayer): ITreeMapData => {
			let children = layer.rows.map((row) => nameValueToObject(row.columns))
				.filter((data) => data['Class Flags Hash']['VISUALISATION'])
				.map((data) => {
					return {
						name: data['Class Description'],
						children: [],
						colour: data['Class Color'],
						value: data['Class Area']
					};
				})
				.filter((c) => c.value !== undefined);
			return {
				name: areaQueryService.queriedLayers.map((l) => l.name).join(' - '),
				children
			};
		};

		let makeTreeMapData = (result: ILayerQueryResult) : ITreeMapData => {
			let layers = result.response.layers;

			if (layers.length == 1) {
				return layerToTreeMapNode(layers[0]);
			}
			let children = layers.map(layerToTreeMapNode);

			return {
				name: $scope.title,
				children,
				value: sumChildren(children)
			};
		};

		let update = () => {
			if (areaQueryService.activeQuery) {
				$scope.title = areaQueryService.queriedLayers.map((l) => l.name).join(' - ');
				areaQueryService.activeQuery.request.then((result) => {
					$scope.treemapData = makeTreeMapData(result);
				}, () => {
					$scope.treemapData = null;
				})
			} else {
				$scope.treemapData = null;
			}

		};

		$scope.$on('newAreaQuery', update);

		$scope.barChartData = null;
		$scope.$watch('treemapData', () => {
			switch (areaQueryService.queriedLayers.length) {
				case 0:
					$scope.barChartData = null;
					break;
				case 1:
					$scope.barChartData = $scope.treemapData;
					break;
				default:
					$scope.barChartData = $scope.treemapData.children;
			}
		});

		update();

		$scope.btnClass = (chart: string) => {
			return {
				'active': $scope.chart === chart
			}
		}
	}
}